<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <overlay></overlay>
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>

import Overlay from './components/Overlay.vue'
import { mapGetters } from 'vuex'

export default {

  components: {
    Overlay
  },
  computed: {
    ...mapGetters(['isLogged'])
  },
  mounted() {
    if (!this.isLogged) {
      this.$store.dispatch('logout')
    }
    this.$store.dispatch('getCategorias')
    this.$store.dispatch('getColecoes')
    this.$store.dispatch('getTags')
  }

}
</script>

<style lang="scss">
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>
